// Reactivo, cuando cambia el state se notifica a todos lados donde esten escuchando los cambios del state
export default () => ({
  isLoading: true,
  semesters: [],
  estanciasAlum: [],
  documentacion: [],
  tipoCarga: "",
  subioDocs: false,
  mostrarMensaje: "",
  constancia: false,
})
